import React, {Component} from 'react';

import '../../styles/elements/imageGridElement.css';

class ImageGridElement extends Component {

  photo = null;
  ref = null;

  constructor(props) {
    super(props);
    this.photo = props.photo;
  }

  handleImageLoaded() {
    this.ref.classList.add('image-grid__container--show');
  }

  render() {
    return (
      <a href={this.photo.url} target="_blank" rel="noopener noreferrer" className={"image-grid__container"}
         data-id={this.props.i} ref={(elem) => {this.ref = elem;}}>
        <div className="image-grid__container-content">
          <img className="image-grid__image" alt={this.photo.name} src={this.photo.img.s440} onLoad={() => {
            this.handleImageLoaded()
          }}/>
          <div className="image-grid__content">
            <div className="image-grid__name">{this.photo.name}</div>
            <i className="fa fa-500px image-grid__network" aria-hidden="true"></i>
          </div>
        </div>
      </a>
    )
  }
}

export default ImageGridElement;



// WEBPACK FOOTER //
// ./src/js/elements/ImageGridElement.js